import {PAYMENT_STATUS} from '../consts';

export const isTransactionDone = ({paymentStatus} = {}) => paymentStatus === PAYMENT_STATUS.DONE;
